import { render, staticRenderFns } from "./AcessarPedidoItensBtnMaisAcoes.vue?vue&type=template&id=400d226d"
import script from "./AcessarPedidoItensBtnMaisAcoes.vue?vue&type=script&lang=js"
export * from "./AcessarPedidoItensBtnMaisAcoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports